import {
  RotateLeftOutlined,
  RotateRightOutlined,
  SwapOutlined,
  ZoomInOutlined,
  ZoomOutOutlined
} from '@ant-design/icons';
import { useQuery } from '@tanstack/react-query';
import { Image, Space } from 'antd';
import { useEffect, useState } from 'react';
import { getOvertimeTicketFile } from 'src/apis/hr_ticket/overtimeTicket.api';
import { ITicketFile } from 'src/types/helpdesk/ticket.type';

interface Props {
  ticketAttachment: ITicketFile;
  size?: number;
}

const OvertimeTicketImage = ({ ticketAttachment, size }: Props) => {
  const [src, setUrl] = useState<string>();

  const ticketAttachmentQuery = useQuery({
    queryKey: ['overtimeTicketImage', ticketAttachment.id],
    queryFn: () => getOvertimeTicketFile(ticketAttachment)
  });

  useEffect(() => {
    if (ticketAttachmentQuery.data?.data) {
      const url = URL.createObjectURL(
        // new Blob([ticketAttachmentQuery.data?.data], {
        //   type: `image/jpeg;charset=UTF-8`
        // })
        new Blob([ticketAttachmentQuery.data?.data])
      );
      setUrl(url);
    }
  }, [ticketAttachmentQuery.data?.data, ticketAttachment]);

  return (
    <Image
      key={ticketAttachment.id}
      width={size ?? 100}
      height={size ?? 100}
      loading={'lazy'}
      src={src}
      preview={{
        toolbarRender: (
          _,
          { transform: { scale }, actions: { onFlipY, onFlipX, onRotateLeft, onRotateRight, onZoomOut, onZoomIn } }
        ) => (
          <Space size={12} className='toolbar-wrapper'>
            <SwapOutlined rotate={90} onClick={onFlipY} />
            <SwapOutlined onClick={onFlipX} />
            <RotateLeftOutlined onClick={onRotateLeft} />
            <RotateRightOutlined onClick={onRotateRight} />
            <ZoomOutOutlined disabled={scale === 1} onClick={onZoomOut} />
            <ZoomInOutlined disabled={scale === 50} onClick={onZoomIn} />
          </Space>
        )
      }}
    />
  );
};

export default OvertimeTicketImage;
